import { getPublicCarouselImages } from '@/services/uploads'

const heroBgImage = require('@/assets/images/hero-bg.webp')

function preloadImage (src) {
  if (!src) return Promise.resolve()
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = () => resolve()
    img.onerror = () => resolve()
    img.src = src
  })
}

function withTimeout (promise, ms) {
  return Promise.race([
    promise,
    new Promise((resolve) => {
      window.setTimeout(resolve, ms)
    })
  ])
}

export async function preloadHomeHero () {
  const carouselPromise = getPublicCarouselImages()
    .then((data) => {
      if (!Array.isArray(data) || data.length === 0) return
      const slide = data[0]
      const isMobile = window.innerWidth <= 768
      const src = isMobile && slide.mobileImage ? slide.mobileImage : slide.image
      return preloadImage(src)
    })
    .catch(() => undefined)

  await Promise.all([
    preloadImage(heroBgImage),
    withTimeout(carouselPromise, 6000)
  ])
}
